























































































import { Component, Vue } from 'vue-property-decorator';
import BaseVue from '@/core/BaseVue';
import GenericEdit from '@/core/Generics/GenericEdit';
import Coin from "@/models/porposal/coin.Model";
@Component
export default class CurrencyEdit extends GenericEdit<Coin> {
  constructor() {
    super();
    this.controller = 'Coins';
    this.model = new Coin();
  }
}
